var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.51465C9.82843 9.51465 10.5 10.1862 10.5 11.0146V23.3146C10.5 24.5995 10.5012 25.473 10.5563 26.1481C10.6101 26.8057 10.7074 27.142 10.827 27.3766C11.1146 27.9411 11.5735 28.4 12.138 28.6877C12.3726 28.8072 12.7089 28.9046 13.3666 28.9583C14.0417 29.0135 14.9151 29.0146 16.2 29.0146H19.8C21.0849 29.0146 21.9583 29.0135 22.6334 28.9583C23.2911 28.9046 23.6274 28.8072 23.862 28.6877C24.4265 28.4 24.8854 27.9411 25.173 27.3766C25.2926 27.142 25.3899 26.8057 25.4437 26.1481C25.4988 25.473 25.5 24.5995 25.5 23.3146V11.0146C25.5 10.1862 26.1716 9.51465 27 9.51465C27.8284 9.51465 28.5 10.1862 28.5 11.0146V23.3766C28.5 24.584 28.5 25.5806 28.4337 26.3924C28.3648 27.2355 28.217 28.0106 27.846 28.7386C27.2708 29.8676 26.3529 30.7854 25.2239 31.3607C24.4959 31.7316 23.7209 31.8795 22.8777 31.9484C22.0659 32.0147 21.0694 32.0147 19.8619 32.0146H16.1381C14.9306 32.0147 13.9341 32.0147 13.1223 31.9484C12.2791 31.8795 11.5041 31.7316 10.7761 31.3607C9.64709 30.7854 8.7292 29.8676 8.15396 28.7386C7.78303 28.0106 7.63518 27.2355 7.56629 26.3924C7.49997 25.5806 7.49998 24.5841 7.5 23.3766L7.5 11.0146C7.5 10.1862 8.17157 9.51465 9 9.51465Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 23.0146C17.1716 23.0146 16.5 23.6862 16.5 24.5146V29.0146H13.5V24.5146C13.5 22.0294 15.5147 20.0146 18 20.0146C20.4853 20.0146 22.5 22.0294 22.5 24.5146V29.0146H19.5V24.5146C19.5 23.6862 18.8284 23.0146 18 23.0146Z",
    fill: "#714FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65869 13.1856C5.02917 13.9266 5.93018 14.2269 6.67115 13.8564L18.0003 8.19186L29.3295 13.8564C30.0705 14.2269 30.9715 13.9266 31.342 13.1856C31.7125 12.4447 31.4121 11.5437 30.6712 11.1732L18.6711 5.17317C18.2489 4.96202 17.7518 4.96202 17.3295 5.17317L5.32951 11.1732C4.58854 11.5437 4.2882 12.4447 4.65869 13.1856Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.200028fdac112e79a61825896142157a.svg";
export { ForwardRef as ReactComponent };